export const companyProfileAPIUrls = {
  save: '/settings/company-profile/save',
  fetch: '/settings/company-profile/fetch',
} as const;
